(function () {
  if (customElements.get('more-in-color')) return;

  class MoreInColor extends HTMLElement {
    connectedCallback() {
      this.collectionUrl = this.dataset.collectionUrl;
      this.optionName = this.dataset.optionName;
      this.currentColor = this.dataset.currentColor;
      this.currentTaxonomy = this.dataset.currentTaxonomy || '';
      this.productId = this.dataset.productId;
      this.imageRatio = this.dataset.imageRatio || 'square';
      this.imageShape = this.dataset.imageShape || 'default';
      this.showSecondaryImage = this.dataset.showSecondaryImage === 'true';
      this.showVendor = this.dataset.showVendor === 'true';
      this.showRating = this.dataset.showRating === 'true';
      this.flkty = null;

      if (!this.collectionUrl) return;

      this.cleanupBreakpoint = window.SliderSettings.onBreakpointChange(() => this.reinitFlickity());

      this.fetchAndRender();

      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        try {
          const newColor = event?.data?.variant?.options?.[0];
          if (newColor && newColor !== this.currentColor) {
            this.currentColor = newColor;
            const sectionId = event?.data?.sectionId;
            const vs = sectionId ? document.getElementById(`variant-selects-${sectionId}`) : null;
            this.currentTaxonomy = vs?.dataset.selectedTaxonomy || '';
            this.fetchAndRender();
          }
        } catch (e) {
          console.error('MoreInColor:', e);
        }
      });
    }

    disconnectedCallback() {
      this.variantChangeUnsubscriber?.();
      this.cleanupBreakpoint?.();
      this.flkty?.destroy();
      this.flkty = null;
    }

    buildUrl() {
      const filter = this.currentTaxonomy
        ? `filter.v.t.shopify.color-pattern=${encodeURIComponent(this.currentTaxonomy)}`
        : `filter.v.option.${encodeURIComponent(this.optionName)}=${encodeURIComponent(this.currentColor)}`;
      return `${this.collectionUrl}?section_id=more-in-color&${filter}&filter.v.availability=1`;
    }

    fetchAndRender() {
      this.abortController?.abort();
      this.abortController = new AbortController();

      fetch(this.buildUrl(), { signal: this.abortController.signal })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const items = [...doc.querySelectorAll('[data-mic-product-id]')].filter((el) => {
            return el.dataset.micProductId !== this.productId;
          });

          if (items.length < 2) {
            this.closest('section').style.display = 'none';
            return;
          }

          this.closest('section').style.display = '';
          const selected = items.sort(() => Math.random() - 0.5).slice(0, 4);
          this.renderSlider(selected);
        })
        .catch((e) => {
          if (e.name === 'AbortError') return;
          this.closest('section').style.display = 'none';
        });
    }

    renderSlider(items) {
      if (this.flkty) {
        this.flkty.destroy();
        this.flkty = null;
      }

      const prevSlider = this.querySelector('.more-in-color__slider');
      if (prevSlider) prevSlider.remove();

      const slider = document.createElement('div');
      slider.className = 'more-in-color__slider';

      items.forEach((item) => {
        const cell = document.createElement('div');
        cell.className = 'more-in-color__cell grid__item';
        const card = item.firstElementChild.cloneNode(true);

        if (this.imageShape !== 'default') card.querySelectorAll('.card__media').forEach((el) => el.classList.add(`shape--${this.imageShape}`));
        const ratioMap = { portrait: '125%', square: '100%' };
        if (ratioMap[this.imageRatio]) card.querySelectorAll('.ratio').forEach((el) => el.style.setProperty('--ratio-percent', ratioMap[this.imageRatio]));
        if (!this.showSecondaryImage) { const imgs = card.querySelectorAll('.media .motion-reduce'); if (imgs.length > 1) imgs[1].remove(); }
        if (!this.showVendor) card.querySelectorAll('.caption-with-letter-spacing').forEach((el) => el.remove());
        if (!this.showRating) card.querySelectorAll('.rating, .rating-text, .rating-count').forEach((el) => el.remove());

        cell.appendChild(card);
        slider.appendChild(cell);
      });

      this.appendChild(slider);

      this.flkty = new Flickity(slider, window.getFlickityOptions(this));

      if (typeof window.datoraUpdatePrices === 'function') {
        Promise.resolve(window.datoraUpdatePrices(this)).finally(() => {
          requestAnimationFrame(() => this.flkty?.resize());
        });
      }
    }

    reinitFlickity() {
      const slider = this.querySelector('.more-in-color__slider');
      if (!slider) return;
      this.flkty?.destroy();
      this.flkty = new Flickity(slider, window.getFlickityOptions(this));
    }
  }

  customElements.define('more-in-color', MoreInColor);
})();
